var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0c1.654 0 3 1.346 3 3v1h5a1 1 0 010 2h-1.091l-1.804 16.117A2.143 2.143 0 0116 24H8a2.141 2.141 0 01-2.104-1.885L4.119 6H3a1 1 0 010-2h5V3c0-1.654 1.346-3 3-3h2zm4.898 6H6.132l1.753 15.896c.004.04.075.104.115.104h8c.041 0 .113-.065.118-.105L17.898 6zM13 2h-2c-.551 0-1 .448-1 1v1h4V3c0-.552-.449-1-1-1z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconRemove;